import { paths } from '../paths';
import { lazyLoadPage } from '../utils';

export const inviteRoutes = [
  {
    path: paths.INVITE_DETAIL(),
    element: lazyLoadPage('', { path: 'invite/' }),
    state: {
      pageKey: 'invite',
      metadata: {
        title: 'Invite'
      }
    }
  },
  {
    path: paths.INVITE_EXPIRED(),
    element: lazyLoadPage('expired', { path: 'invite/' }),
    state: {
      pageKey: 'expired',
      metadata: {
        title: 'Invite Expired'
      }
    }
  }
];
